// Copyright 2018 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

const words = [
  'eat',
  'tea',
  'ate',
  'tie',
  'tai',
  'tei',
  'ait',
  'mat',
  'met',
  'team',
  'mate',
  'meet',
  'mitt',
  'meat',
  'aim',
  'tame',
  'same',
  'sat',
  'sit',
  'set',
  'steam',
  'teams',
  'meats',
  'meets',
  'mates',
  'mats',
  'ties',
  'eats',
  'aims',
  'some',
  'toss',
  'time',
  'mom',
  'sometimes',
  'osmosis',
  'moss',
  'moose',
  'tomato',
  'home',
  'hot',
  'hat',
  'ham',
  'shoot',
  'shot',
  'mosh',
  'mash',
  'stash',
  'hash',
  'home',
  'homes',
  'moth',
  'math',
  'the',
  'son',
  'nose',
  'net',
  'not',
  'note',
  'tent',
  'someone',
  'mint',
  'hint',
  'stone',
  'moan',
  'honest',
  'cat',
  'come',
  'can',
  'mathematics',
  'sonic',
  'tonic',
  'chase',
  'match',
  'hatch',
  'mooch',
  'notch',
  'cash',
  'car',
  'rat',
  'rice',
  'ear',
  'racecar',
  'ran',
  'cram',
  'crash',
  'harm',
  'monitor',
  'roam',
  'runner',
  'rutter',
  'hotter',
  'dad',
  'date',
  'dot',
  'dash',
  'crashed',
  'honed',
  'minted',
  'diminish',
  'credit',
  'honored',
  'crush',
  'minute',
  'dust',
  'crust',
  'crusade',
  'crude',
  'dock',
  'make',
  'rock',
  'ruckus',
  'crude',
  'kook',
  'rookie',
  'duck',
  'crudite',
  'hunk',
  'think',
  'shock',
  'lake',
  'let',
  'land',
  'lose',
  'small',
  'lost',
  'clock',
  'lock',
  'luck',
  'lunch',
  'drool',
  'loud',
  'angel',
  'angle',
  'llama',
  'fake',
  'fat',
  'fun',
  'fur',
  'fast',
  'fluff',
  'fluke',
  'flustered',
  'ruffle',
  'duffle',
  'bat',
  'ball',
  'but',
  'black',
  'blast',
  'back',
  'backside',
  'curb',
  'basketball',
  'baseball',
  'ballet',
  'bottle',
  'bumble',
  'babble',
  'better',
  'rumble',
  'pet',
  'pal',
  'help',
  'up',
  'plaster',
  'crumple',
  'postmark',
  'pretend',
  'pub',
  'lump',
  'bump',
  'dump',
  'hump',
  'prescribed',
  'great',
  'get',
  'game',
  'gain',
  'dog',
  'big',
  'gaping',
  'paging',
  'page',
  'baggage',
  'package',
  'rampage',
  'jump',
  'jet',
  'juggle',
  'jacket',
  'jaguar',
  'japan',
  'jam',
  'jetpack',
  'jungle',
  'van',
  'vet',
  'vacuum',
  'vacant',
  'pave',
  'vampire',
  'volcano',
  'question',
  'quick',
  'quit',
  'quilt',
  'quadratic',
  'quantum',
  'quaint',
  'query',
  'quail',
  'squat',
  'squad',
  'equal',
  'with',
  'water',
  'wear',
  'what',
  'weather',
  'jaw',
  'paw',
  'weekend',
  'week',
  'wave',
  'waffle',
  'guffaw',
  'beeswax',
  'wax',
  'tax',
  'apex',
  'axel',
  'flax',
  'jinx',
  'boxed',
  'boxer',
  'toxic',
  'detox',
  'exile',
  'exit',
  'very',
  'yes',
  'jelly',
  'jellyfish',
  'walkway',
  'yesterday',
  'zipper',
  'zebra',
  'dizzy',
  'graze',
  'zesty',
  'razer',
  'brazil',
  'zone',
  'jazz',
  'zero',
  'tee',
  'tie',
  'it',
  'ite',
  'eit',
  'mat',
  'met',
  'team',
  'mate',
  'meet',
  'mitt',
  'meat',
  'aim',
  'tame',
  'mime',
  'item',
  'me',
  'meta',
  'time',
  'same',
  'sat',
  'sit',
  'set',
  'steam',
  'teams',
  'seem',
  'seam',
  'aims',
  'eats',
  'miss',
  'mist',
  'esteem',
  'steer',
  'seat',
  'some',
  'toss',
  'time',
  'mom',
  'sometimes',
  'osmosis',
  'moss',
  'moose',
  'tomato',
  'too',
  'to',
  'so',
  'soot',
  'moot',
  'moat',
  'miso',
  'home',
  'hot',
  'hat',
  'ham',
  'shoot',
  'shot',
  'mosh',
  'mash',
  'stash',
  'hash',
  'home',
  'homes',
  'moth',
  'math',
  'host',
  'teeth',
  'seethe',
  'hoot',
  'hoist',
  'heist',
  'haste',
  'soothe',
  'oh',
  'the',
  'son',
  'nose',
  'net',
  'not',
  'note',
  'tent',
  'someone'
];

module.exports = words;
